// 全局区域筛选状态：管理后台顶部 cascader 选择的省/市
// 各业务页面通过 store.state.region 或 getter region 读取并据此请求带参的接口
import Cookies from 'js-cookie'

const COOKIE_KEY = 'adminRegionFilter'

function loadFromCookie() {
  try {
    const raw = Cookies.get(COOKIE_KEY)
    if (!raw) return []
    const arr = JSON.parse(raw)
    return Array.isArray(arr) ? arr : []
  } catch (e) {
    return []
  }
}

const state = {
  // 数组形式：[] 全部、['江苏省'] 省级、['江苏省','苏州市'] 市级
  selected: loadFromCookie()
}

const mutations = {
  SET_REGION: (state, value) => {
    state.selected = Array.isArray(value) ? value : []
    if (state.selected.length === 0) {
      Cookies.remove(COOKIE_KEY)
    } else {
      Cookies.set(COOKIE_KEY, JSON.stringify(state.selected))
    }
  }
}

const actions = {
  setRegion({ commit }, value) {
    commit('SET_REGION', value)
  },
  clearRegion({ commit }) {
    commit('SET_REGION', [])
  }
}

const getters = {
  regionSelected: state => state.selected,
  regionParams: state => {
    const params = {}
    if (state.selected.length >= 1) params.province = state.selected[0]
    if (state.selected.length >= 2) params.city = state.selected[1]
    return params
  },
  regionScopeLabel: state => {
    if (state.selected.length === 0) return '全部'
    return state.selected.join(' / ')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
